module.exports = "/_next/static/images/favicon-16x16-1b667093097f2c2dc0111644520b6658.png";